// @flow
import type { InitAction, InitState } from './init.types';
import type { ActionCreator } from 'redux';

/*** Framework ***/
import Raven from 'raven-js';

/*** Actions ***/
export const INIT: string = 'UI/INIT';
export const INIT_SUCCESS: string = 'UI/INIT_SUCCESS';
export const INIT_ERROR: string = 'UI/INIT_ERROR';

export const SET_CLIENTCODE = 'UI/SET_CLIENTCODE';
export const SET_CLIENT_UI = 'UI/SET_CLIENT_UI';
export const SET_CLIENT = 'UI/INIT/SET_CLIENT';

/*** Action Creators ***/
export const initApp: ActionCreator<InitAction, void> = () => ({
  type: INIT
});

export const initAppSuccess: ActionCreator<InitAction, void> = () => ({
  type: INIT_SUCCESS
});

export const initAppError: ActionCreator<InitAction, Error> = (error) => ({
  type: INIT_ERROR,
  error
});

export const setClientCode: ActionCreator<InitAction, void> = (clientCode) => ({
  type: SET_CLIENTCODE,
  clientCode
});

export const setClientUi: ActionCreator<InitAction, void> = (client) => ({
  type: SET_CLIENT_UI,
  client
});

export const setClient: ActionCreator<InitAction, void> = (client) => ({
  type: SET_CLIENT,
  client
});

/*** Reducer ***/
export const DEFAULT_STATE: InitState = {
  clientCode: 'NovusGeneric',
  client: {
    name: '',
    data: {
      dashboard: {
        theme: {
          label: '',
          color: '',
          logo: '',
          faivcon: null
        }
      }
    },
    reset_password_link: '',
    products: []
  }
};

export default function InitReducer(
  state: InitState = DEFAULT_STATE,
  { type, clientCode, client, error }: InitAction = {}
): InitState {
  switch (type) {
    case INIT_ERROR:
      if (error) Raven.captureException(error, { state });
      return {
        ...state,
        error
      };
    case SET_CLIENTCODE:
      return {
        ...state,
        clientCode
      };
    case SET_CLIENT:
      return {
        ...state,
        client
      };
    case INIT_SUCCESS:
    case INIT:
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/actions/ui/init/initActions.js